import { useState } from "react";
import { Check, Copy, X, MessageCircle, Mail } from "lucide-react";

export default function CopyInviteModal({ email, role, academyName, emailSent, emailDetail, onClose }) {
  const inviteUrl = `${window.location.origin}/app`;
  const [copied, setCopied] = useState("");
  const message = `Hey! You've been invited to manage ${academyName || "the academy"} on RollOSS as a ${role}.\n\nSign in with your Google account at ${inviteUrl} (use ${email}). See you on the mats. 🥋`;

  const copy = async (text, key) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(key);
      setTimeout(() => setCopied(""), 1800);
    } catch (e) { /* ignore */ }
  };

  const waUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
  const mailUrl = `mailto:${email}?subject=${encodeURIComponent("You've been invited to RollOSS")}&body=${encodeURIComponent(message)}`;

  return (
    <div style={{position:"fixed", inset:0, background:"rgba(0,0,0,0.75)", display:"grid", placeItems:"center", zIndex:60}} onClick={onClose}>
      <div className="card p-7 w-[520px] max-w-[92vw]" onClick={e=>e.stopPropagation()} data-testid="copy-invite-modal">
        <div className="flex items-center justify-between mb-5">
          <div>
            <div className="label" style={{color:"var(--green)"}}>Invitation ready</div>
            <div className="text-[20px] font-bold uppercase mt-1 tracking-tight">Share with {email}</div>
          </div>
          <button onClick={onClose} data-testid="invite-close"><X size={18}/></button>
        </div>

        {emailSent === true && (
          <div className="pill pill-active mb-4" data-testid="email-sent-ok">
            <Check size={11}/> Email sent automatically to {email}
          </div>
        )}
        {emailSent === false && (
          <div className="pill pill-late mb-4" data-testid="email-sent-fail" title={emailDetail || ""}>
            Email not sent — share the link manually below
          </div>
        )}

        <div className="label mb-2">Invite link</div>
        <div className="card flex items-center gap-2 p-3" data-testid="invite-link">
          <code className="flex-1 mono text-[13px] truncate" style={{color:"var(--green)"}}>{inviteUrl}</code>
          <button onClick={()=>copy(inviteUrl,"link")} className="btn btn-outline" style={{padding:"6px 12px", fontSize:11}} data-testid="copy-link-btn">
            {copied==="link" ? <><Check size={12}/>Copied</> : <><Copy size={12}/>Copy</>}
          </button>
        </div>

        <div className="label mt-5 mb-2">Or send the whole message</div>
        <div className="card p-3" data-testid="invite-message">
          <pre className="text-[13px] leading-relaxed whitespace-pre-wrap" style={{color:"var(--text)", fontFamily:"inherit"}}>{message}</pre>
        </div>
        <div className="flex flex-wrap gap-2 mt-3">
          <button onClick={()=>copy(message,"msg")} className="btn btn-outline" data-testid="copy-msg-btn">
            {copied==="msg" ? <><Check size={12}/>Copied</> : <><Copy size={12}/>Copy message</>}
          </button>
          <a href={waUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline" data-testid="share-whatsapp">
            <MessageCircle size={12}/> WhatsApp
          </a>
          <a href={mailUrl} className="btn btn-outline" data-testid="share-email">
            <Mail size={12}/> Email
          </a>
        </div>

        <div className="label-tiny mt-5 leading-relaxed">
          They'll be auto-recognised on first Google sign-in. No email sent automatically — share the link manually for now.
        </div>
        <button onClick={onClose} className="btn btn-primary w-full mt-5" data-testid="invite-done">Done</button>
      </div>
    </div>
  );
}
